import * as MD from "@material-ui/core/";
import * as React from "react";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { IApplicationState } from "../../Store";
import { ILayoutState } from "../../Store/Layout/Types";
import { I18N, ILocaleInfos } from "../../Store/I18n/Types";

import { getTheme, PaletteMode } from "../../Themes";

import {
  IDashboardState,
  IDateType,
  IDisplayFormat,
  IFilters,
} from "../../Store/Dashboard/Types";
import { ISearchState } from "../../Store/Search/Types";
import { PeriodSelection, PeriodSelectionComponent } from "../PeriodSelection";
import {
  getDashboard,
  setDisplayFormat,
  getAutocompleteEmission,
  clearEmissionList,
} from "../../Store/Dashboard/Actions";
import { hideDrawer, showDrawer } from "../../Store/Layout/Actions";
import { isNullOrUndefined } from "../../Utils/Various";
import { IUserState } from "../../Store/User/Types";
import { RouteComponentProps } from "react-router-dom";
import { resetFilters } from "../../Store/Search/Actions";
import {
  ElectionType,
  IDeclarationCSAFilters,
  IElectionFilters,
  IElectionsState,
  IElectionsStudyType,
  IElectionDetailFilters,
  PRESIDENTIEL_ELECTION,
} from "../../Store/Elections/Types";
import { ElectionSelect } from "./ElectionSelect";
import {
  getCircoList,
  getCircoVirtList,
  getDashboardCirconscription,
  getDashboardElection,
  getDeclarationCSA,
  getTimeAllocation,
  getTimeAllocationLegislative,
  setStudyType,
} from "../../Store/Elections/Actions";
import { Dialog } from "../Dialog";
import { FiltersSection } from "./FiltersSection";
import {
  getCurrentEtude,
  isElectionNational,
} from "../../Store/Elections/Reducer";
import {
  adjustForTimezone,
  getDateHourZero,
  minMaxDates
} from "../../Utils/Time";
import Autocomplete from "@material-ui/lab/Autocomplete";
import styles from "./DashboardDrawer.style";

const theme = getTheme();

interface IPropsFromState {
  i18n: I18N;
  layout: ILayoutState;
  localeInfos: ILocaleInfos;
  search: ISearchState;
  dashboard: IDashboardState;
  user: IUserState;
  elections: IElectionsState;
  router: RouteComponentProps<{}>;
}

interface InitialState {
  openError: boolean;
  errorMessage: string;
  open: boolean;
  startDate: Date;
  endDate: Date;
  startSlot: Date;
  endSlot: Date;
  selectedYear: number;
  dateType: IDateType;
  // medias state
  mediasID: number[] | null;
  mediasStr: string[];
  isAllMediasSelected: boolean;
  // program types state
  programTypesID: number[] | null;
  programTypesStr: string[];
  isAllProgramTypesSelected: boolean;
  // elections state
  electionsID: number | null;
  electionsIDArray: number[];
  detailEtudeID: number[];
  // program editors state
  programEditorsID: number[] | null;
  programEditorStr: string[];
  isAllProgramEditorsSelected: boolean;
  //datePicker
  isFullYearSelected: boolean;
  isSem1Activated: boolean;
  isSem2Activated: boolean;
  isTrim1Selected: boolean;
  isTrim2Selected: boolean;
  isTrim3Selected: boolean;
  isTrim4Selected: boolean;
  selectedMonthIndex: number | null;
  firstSearch: boolean;
  // program name autocomplete
  programName: string;
}

interface IOwnState { }

interface IPropsFromDispatch {
  getDashboard: typeof getDashboard;
  setDisplayFormat: typeof setDisplayFormat;
  hideDrawer: typeof hideDrawer;
  showDrawer: typeof showDrawer;
  resetFilters: typeof resetFilters;
  getCircoList: typeof getCircoList;
  getCircoVirtList: typeof getCircoVirtList;
  getDashboardElection: typeof getDashboardElection;
  getDashboardCirconscription: typeof getDashboardCirconscription;
  getDeclarationCSA: typeof getDeclarationCSA;
  setStudyType: typeof setStudyType;
  getTimeAllocation: typeof getTimeAllocation;
  getTimeAllocationLegislative: typeof getTimeAllocationLegislative;
  getAutocompleteEmission: typeof getAutocompleteEmission;
  clearEmissionList: typeof clearEmissionList;
}

type IAppState = InitialState & IOwnState;

type AllProps = MD.WithTheme &
  MD.WithStyles<typeof styles> &
  IPropsFromState &
  IPropsFromDispatch;

const hourZero = () => {
  const newSlot = new Date(0);
  newSlot.setHours(0);
  return newSlot;
};

let newDate = getDateHourZero(new Date());
const initialState: InitialState = {
  openError: false,
  errorMessage: "",
  open: true,
  selectedYear: newDate.getFullYear(),
  dateType: "month",
  startDate: new Date(newDate.getFullYear(), newDate.getMonth(), 1),
  endDate: newDate,
  startSlot: hourZero(),
  endSlot: hourZero(),
  mediasID: null,
  mediasStr: [],
  isAllMediasSelected: true,
  programTypesID: null,
  programTypesStr: [],
  isAllProgramTypesSelected: true,
  electionsID: null,
  electionsIDArray: [],
  detailEtudeID: [-1],
  programEditorsID: null,
  programEditorStr: [],
  isAllProgramEditorsSelected: true,
  isSem1Activated: false,
  isSem2Activated: false,
  isFullYearSelected: false,
  isTrim1Selected: false,
  isTrim2Selected: false,
  isTrim3Selected: false,
  isTrim4Selected: false,
  selectedMonthIndex: null,
  firstSearch: true,
  programName: "",
};

export class DashboardDrawerComponent extends React.Component<
  AllProps,
  IAppState
> {
  private PeriodRef: React.RefObject<PeriodSelectionComponent>;
  public constructor(props: AllProps) {
    super(props);

    this.PeriodRef = React.createRef<PeriodSelectionComponent>();
    if (props.dashboard.dateCloture !== null) {
      // On considère dateCloture comme le dernier jour inclus,
      // et on applique ensuite la même logique que dans PeriodSelection :
      // endDate = lendemain à minuit (borne exclusive).
      const inclusiveEnd = getDateHourZero(props.dashboard.dateCloture);
      const exclusiveEnd = adjustForTimezone(
        new Date(inclusiveEnd.getTime() + 24 * 60 * 60 * 1000)
      );

      initialState.endDate = exclusiveEnd;
      initialState.startDate = new Date(
        inclusiveEnd.getFullYear(),
        inclusiveEnd.getMonth(),
        1
      );
    }
    this.state = {
      ...initialState,
    };
  }

  static getDerivedStateFromProps(props: AllProps, state: IAppState) {
    const { search, user, elections, dashboard } = props;
    const nextState: Partial<IAppState> = {};

    // Initialize program types once
    if (search.allProgramTypesID.length > 0 && state.programTypesID === null) {
      nextState.programTypesID = search.allProgramTypesID;
      nextState.programTypesStr = search.allProgramTypesSTR;
    }

    // Initialize elections info once
    if (
      elections.elections_study_types.length > 0 &&
      state.electionsID === null
    ) {
      let electionsList = [...elections.elections_study_types].filter(
        (x) => x.id >= PRESIDENTIEL_ELECTION.FIRST_ROUND
      );
      const current = getCurrentEtude(electionsList);
      nextState.electionsID = current.id;
      nextState.electionsIDArray = electionsList.map((x) => x.id);
      // Do NOT set startDate/endDate here — dates are managed by Branch C (firstSearch default)
      // and componentDidUpdate (on mode toggle). Setting them from getCurrentEtude (= newest/future
      // election) would override the correct current-month defaults.
    }

    // Initialize medias once
    if (user.allMediasID.length > 0 && state.mediasID === null) {
      // Par défaut on sélectionne tous les médias (équivalent au clic sur "ALL")
      nextState.mediasID = user.allMediasID;
      nextState.mediasStr = user.allMediasSTR;
      nextState.isAllMediasSelected = true;
    }

    // Initialize program editors once
    if (
      search.allProgramEditorsID !== null &&
      state.programEditorsID === null
    ) {
      nextState.programEditorsID = search.allProgramEditorsID;
      nextState.programEditorStr = search.allProgramEditorsSTR;
    }

    // Date defaults on first load (current month, both elections and pluralisme modes)
    if (dashboard.dateCloture !== null) {
      if (
        search.allProgramTypesID.length > 0 &&
        search.allProgramEditorsID !== null &&
        user.allMediasID.length > 0 &&
        state.firstSearch
      ) {
        const inclusiveEnd = getDateHourZero(dashboard.dateCloture);
        const exclusiveEnd = new Date(
          inclusiveEnd.getTime() + 24 * 60 * 60 * 1000
        );

        // Default to current month regardless of elections/pluralisme mode.
        // Election campaign dates are applied only on explicit mode switch (componentDidUpdate).
        nextState.endDate = exclusiveEnd;
        nextState.startDate = new Date(
          inclusiveEnd.getFullYear(),
          inclusiveEnd.getMonth(),
          1
        );
        // Par défaut, tous les médias sont sélectionnés
        nextState.mediasID = user.allMediasID;
        nextState.mediasStr = user.allMediasSTR;
        nextState.isAllMediasSelected = true;
        nextState.programTypesID = search.allProgramTypesID;
        nextState.programTypesStr = search.allProgramTypesSTR;

        if (search.timeFilters !== null && !elections.isElectionChecked) {
          nextState.startDate = search.timeFilters.startDate;
          nextState.endDate = search.timeFilters.endDate;
          nextState.dateType = search.timeFilters.dateType;
        }

        if (
          search.searchFilters !== null &&
          search.searchFilters.media_str !== null &&
          search.searchFilters.program_types_str !== null
        ) {
          nextState.mediasID = search.searchFilters.media_ids;
          nextState.mediasStr = search.searchFilters.media_str;
          nextState.programTypesID = search.searchFilters.program_types_ids;
          nextState.programTypesStr = search.searchFilters.program_types_str;
          nextState.isAllMediasSelected =
            search.searchFilters.media_ids.length === user.allMediasID.length;
          nextState.isAllProgramTypesSelected =
            search.searchFilters.program_types_ids.length ===
            search.allProgramTypesID.length;
        }
        nextState.firstSearch = false;
      }
    }

    return Object.keys(nextState).length > 0 ? nextState : null;
  }

  componentDidUpdate(prevProps: AllProps) {
    const { elections, dashboard } = this.props;
    const toggledElection =
      elections.isElectionChecked !== prevProps.elections.isElectionChecked;
    const studyTypeChanged =
      elections.study_type_id !== prevProps.elections.study_type_id;
    const hasDateCloture = dashboard.dateCloture !== null;

    let pendingUpdate: Partial<IAppState> = {};
    let applyReset = false;

    if (toggledElection) {
      if (hasDateCloture) {
        pendingUpdate.endDate = dashboard.dateCloture as Date;
      }
      if (
        elections.elections_study_types &&
        elections.elections_study_types.length > 0
      ) {
        pendingUpdate.electionsID = elections.isElectionChecked
          ? getCurrentEtude(elections.elections_study_types).id
          : 24;
        pendingUpdate.electionsIDArray = elections.elections_study_types.map(
          (x) => x.id
        );
      }
    }

    if ((toggledElection || studyTypeChanged) && hasDateCloture) {
      if (toggledElection) {
        applyReset = true;
      }
      const dateCloture = dashboard.dateCloture as Date;

      // For studyTypeChanged-only (no mode toggle): only recompute dates if elections_start_date
      // is a valid past/current date. Future election start dates (e.g. from GET_STUDY_TYPES_SUCCESS
      // which uses the newest election) should not override the current-month defaults set on load.
      const electionsStartIsValid = elections.elections_start_date !== null &&
        new Date(elections.elections_start_date).getTime() <= dateCloture.getTime();
      const shouldUpdateDates = toggledElection || electionsStartIsValid;

      if (shouldUpdateDates) {
        let computedEnd = dateCloture;
        let computedStart = new Date(
          dateCloture.getUTCFullYear(),
          dateCloture.getUTCMonth(),
          1
        );

        if (
          elections.isElectionChecked &&
          elections.elections_start_date &&
          elections.elections_end_date
        ) {
          const electionsEnd = elections.elections_end_date;
          computedEnd = minMaxDates([dateCloture, electionsEnd]).minDate;
          // adjustForTimezone converts the UTC-stored date to local midnight
          // (e.g. "2026-02-01 23:00 UTC" → Feb 2 00:00 CET)
          const adjustedStart = adjustForTimezone(new Date(elections.elections_start_date));
          computedStart = minMaxDates([adjustedStart, computedEnd]).minDate;
        }
        computedStart = getDateHourZero(computedStart);

        // computedEnd est le dernier jour inclus, on passe à la borne exclusive
        const inclusiveEnd = getDateHourZero(computedEnd);
        const exclusiveEnd = new Date(
          inclusiveEnd.getTime() + 24 * 60 * 60 * 1000
        );
        pendingUpdate = {
          ...pendingUpdate,
          startDate: computedStart,
          endDate: exclusiveEnd,
          electionsID: elections.study_type_id,
        };
      } else {
        // Future election: just update the election ID, keep current dates
        pendingUpdate.electionsID = elections.study_type_id;
      }

      if (
        elections.elections_study_types &&
        elections.elections_study_types.length > 0
      ) {
        pendingUpdate.electionsIDArray = elections.elections_study_types.map(
          (x) => x.id
        );
      }
    }

    if (Object.keys(pendingUpdate).length > 0) {
      if (applyReset) {
        // Prevent Branch C (getDerivedStateFromProps) from re-running after the reset
        // and overriding the election dates we just computed.
        this.setState({ ...initialState, ...pendingUpdate, firstSearch: false });
      } else {
        this.setState(pendingUpdate as IAppState);
      }
    }
  }
  private handleClose = () => {
    this.setState({ openError: false });
  };

  private handleDateFormat(e: any) {
    this.props.setDisplayFormat(e.target.value);
  }
  private buildSelectDateFormat() {
    const { classes, i18n, dashboard } = this.props;
    const currentDisplayFormat =
      dashboard.filters.display_format || ("duration" as IDisplayFormat);
    return (
      <div
        style={{
          justifyContent: "space-around",
          display: "inline-flex",
          width: "100%",
        }}
      >
        <MD.Typography className={classes.DateLabel}>
          {i18n._("Show results")}
        </MD.Typography>
        <div style={{ display: "inline-flex", textAlign: "center" }}>
          <MD.Checkbox
            style={{
              color:
                currentDisplayFormat === "duration"
                  ? theme.palette.primary.main
                  : theme.palette.primary.light,
            }}
            checked={currentDisplayFormat === "duration"}
            value={"duration"}
            onClick={(e: any) => {
              this.handleDateFormat(e);
            }}
          />
          <MD.ListItemText
            primary={i18n._("in duration")}
            style={{ padding: "5px", marginTop: 10 }}
          />
          <MD.Checkbox
            style={{
              color:
                currentDisplayFormat === "percent"
                  ? theme.palette.primary.main
                  : theme.palette.primary.light,
            }}
            checked={currentDisplayFormat === "percent"}
            value={"percent"}
            onClick={(e: any) => {
              this.handleDateFormat(e);
            }}
          />
          <MD.ListItemText
            primary={`${i18n._("in")} %`}
            style={{ padding: "5px", marginTop: 10 }}
          />
        </div>
      </div>
    );
  }
  private buildSearchButton() {
    return (
      <div style={{ width: "100%", marginBottom: "20px" }}>
        <MD.FormControl
          style={{ width: "50%" }}
          className={this.props.classes.formControl}
        >
          <MD.Button
            className={this.props.classes.resetButton}
            color="secondary"
            onClick={this.onReset.bind(this)}
            variant="contained"
          >
            {this.props.i18n._("Reset")}
          </MD.Button>
        </MD.FormControl>
        <MD.FormControl
          style={{ width: "50%" }}
          className={this.props.classes.formControl}
        >
          <MD.Button
            className={this.props.classes.searchButton}
            color="secondary"
            onClick={() => {
              this.onSearch();
            }}
            variant="contained"
          >
            {this.props.i18n._("Search")}
          </MD.Button>
        </MD.FormControl>
      </div>
    );
  }

  private saveDates(
    startDate: Date,
    endDate: Date,
    startSlot: Date,
    endSlot: Date,
    dateType: IDateType
  ) {
    this.setState({
      startDate: startDate,
      endDate: endDate,
      startSlot: startSlot,
      endSlot: endSlot,
      dateType: dateType,
    });
  }

  componentWillUnmount() {
    this.props.showDrawer();
  }

  private onSearch() {
    const { i18n, elections, dashboard } = this.props;
    let newState = { ...this.state };
    let detailEtudeID =
      newState.detailEtudeID[0] === -1
        ? [
          elections.detail_etude_ids.PAROLE,
          elections.detail_etude_ids.ANTENNE,
        ]
        : newState.detailEtudeID;
    let startDateCopy: Date = new Date(newState.startDate);
    let endDateCopy: Date = new Date(newState.endDate);
    let startSlotCopy: Date = new Date(newState.startSlot);
    let endSlotCopy: Date = new Date(newState.endSlot);
    const startTimeStr = startSlotCopy
      .toTimeString()
      .split(" ")[0]
      .substring(0, 5);
    const endTimeStr = endSlotCopy.toTimeString().split(" ")[0].substring(0, 5);
    try {
      const startMin = startDateCopy.getMinutes();
      const endMin = endDateCopy.getMinutes();
      if (startMin % 15 !== 0 || endMin % 15 !== 0) {
        console.warn(
          "[DashboardDrawer] Backend expects 15-minute slices; selected 15-minute value(s)",
          { startTimeStr, endTimeStr }
        );
      }
    } catch { }
    let msg: string = "",
      error: boolean = false,
      delimiter: string = "";
    if (this.state.mediasID !== null && this.state.mediasID.length === 0) {
      msg = i18n._("Please select a media !");
      error = true;
      delimiter = msg + "\n";
    }
    if (
      this.state.programTypesID !== null &&
      this.state.programTypesID.length === 0
    ) {
      msg = delimiter + i18n._("Please select a program type !");
      error = true;
    }
    let pathParts: string[] = [""];
    if (this.props.router !== undefined) {
      pathParts = this.props.router.location.pathname.split("/");
    }

    this.setState({ openError: error, errorMessage: msg, firstSearch: false });
    const displayFormat =
      dashboard.filters.display_format || ("duration" as IDisplayFormat);

    if (
      !error &&
      this.state.programTypesID !== null &&
      this.state.mediasID !== null &&
      this.state.programEditorsID !== null
    ) {
      if (
        this.props.elections.isElectionChecked &&
        this.state.electionsID !== null
      ) {
        if (
          this.props.router !== undefined &&
          pathParts[1] === "declarationsARCOM"
        ) {
          this.props.getDeclarationCSA({
            study_type_id: this.state.electionsID,
            date_start: this.state.startDate,
            date_end: this.state.endDate,
            media_ids: this.state.mediasID,
          });
        } else {
          if (this.props.elections.isElectionPresedentielle) {
            this.props.getTimeAllocation({
              details_etude_id: detailEtudeID,
              study_type_id: this.state.electionsID,
              date_start: this.state.startDate,
              date_end: this.state.endDate,
              time_slot_start: startTimeStr,
              time_slot_end: endTimeStr,
              media_ids: this.state.mediasID,
              program_type_ids: this.state.programTypesID,
              program_editor_ids: this.state.programEditorsID,
            });
          } else if (this.props.elections.isElectionsLegislative) {
            this.props.getTimeAllocationLegislative({
              study_type_id: this.state.electionsID, //37
              date_start: this.state.startDate,
              date_end: this.state.endDate,
              time_slot_start: startTimeStr,
              time_slot_end: endTimeStr,
              media_ids: this.state.mediasID,
              media_str: this.state.mediasStr,
              program_type_ids: this.props.search.allProgramTypesID,
              program_editor_ids: this.state.programEditorsID,
              program_editor_str: this.state.programEditorStr,
              is_nat: this.props.elections.tableType === ElectionType.NATIONAL,
              detail_etude_id: this.props.elections.circoFilters.circo_ids,
            });
          } else if (this.props.elections.tableType === ElectionType.NATIONAL) {
            this.props.getDashboardElection({
              study_type_id: this.state.electionsID, //37
              date_start: this.state.startDate,
              date_end: this.state.endDate,
              time_slot_start: startTimeStr,
              time_slot_end: endTimeStr,
              media_ids: this.state.mediasID,
              media_str: this.state.mediasStr,
              program_type_ids: this.props.search.allProgramTypesID,
              program_editor_ids: this.state.programEditorsID,
              program_editor_str: this.state.programEditorStr,
              is_nat: true,
            });
          } else {
            let is_nat: boolean =
              this.props.elections.tableType === ElectionType.CIRCONSCRIPTION &&
                (this.state.electionsID === 30 || this.state.electionsID === 32)
                ? true
                : false;
            let details_ids: any =
              this.props.elections.tableType === ElectionType.CIRCONSCRIPTION
                ? this.props.elections.circoFilters.circo_ids
                : this.props.elections.circoFilters.circo_virt_ids;
            this.props.getDashboardCirconscription({
              is_nat,
              study_type_id: this.state.electionsID, //37
              date_start: this.state.startDate,
              date_end: this.state.endDate,
              time_slot_start: startTimeStr,
              time_slot_end: endTimeStr,
              media_ids: this.state.mediasID,
              media_str: this.state.mediasStr,
              program_type_ids: this.props.search.allProgramTypesID,
              program_editor_ids: this.state.programEditorsID,
              program_editor_str: this.state.programEditorStr,
              detail_etude_id: details_ids,
            });
          }
        }
      } else if (!this.props.elections.isElectionChecked) {
        if (
          this.props.router !== undefined &&
          pathParts[1] === "declarationsARCOM"
        ) {
          this.props.getDeclarationCSA({
            study_type_id: 24,
            date_start: this.state.startDate,
            date_end: this.state.endDate,
            media_ids: this.state.mediasID,
          });
        } else {
          this.props.getDashboard({
            media_ids: this.state.mediasID,
            program_type_ids: this.state.programTypesID,
            media_str: this.state.mediasStr,
            program_type_str: this.state.programTypesStr,
            program_editors_ids: this.state.programEditorsID,
            program_editors_str: this.state.programEditorStr,
            time_slot_start: startTimeStr,
            time_slot_end: endTimeStr,
            date_type: this.state.dateType,
            date_start: this.state.startDate,
            date_end: this.state.endDate,
            display_format: displayFormat,
            program_name: this.state.programName,
          });
        }
      }

      !this.props.elections.isElectionChecked && this.props.hideDrawer();
    }
  }
  private onReset() {
    if (this.PeriodRef && this.PeriodRef.current) {
      this.PeriodRef.current!.onReset();
    }
    let endDate = new Date();
    if (this.props.dashboard.dateCloture !== null) {
      endDate = this.props.dashboard.dateCloture;
    }
    this.setState({
      ...initialState,
      selectedYear: endDate.getFullYear(),
      startDate: new Date(endDate.getFullYear(), endDate.getUTCMonth(), 1),
      endDate: endDate,
    });
    this.props.resetFilters();
    this.props.clearEmissionList();
  }
  private buildFiltersInfos() {
    const { classes, i18n, theme } = this.props;
    let medias = this.state.mediasStr.filter((x) => x !== "").join(", ");
    let types = this.state.programTypesStr.filter((x) => x !== "").join(", ");
    let election =
      this.state.electionsID !== null &&
      this.props.elections.elections_study_types.filter(
        (x: any) => x.id === this.state.electionsID
      )[0] !== undefined &&
      this.props.elections.elections_study_types.filter(
        (x: any) => x.id === this.state.electionsID
      )[0].name;

    return (
      <div
        id="infos"
        className={classes.ifilters}
        style={{
          color:
            theme.palette.type === PaletteMode.DARK
              ? theme.palette.primary.main
              : theme.palette.secondary.main,
        }}
      >
        {("0" + this.state.startDate.getDate()).slice(-2)}-
        {("0" + (this.state.startDate.getMonth() + 1)).slice(-2)}-
        {this.state.startDate.getFullYear().toString().substring(2, 4)}
        {" " + i18n._("at") + " "}
        {("0" + this.state.endDate.getDate()).slice(-2)}-
        {("0" + (this.state.endDate.getMonth() + 1)).slice(-2)}-
        {this.state.endDate.getFullYear().toString().substring(2, 4)}
        {" > "}
        {i18n._("from")}{" "}
        {this.state.startSlot.toTimeString().split(" ")[0].substring(0, 5)}{" "}
        {i18n._("to")}{" "}
        {this.state.endSlot.toTimeString().split(" ")[0].substring(0, 5)}
        {this.state.mediasStr.length > 0 && " > "}
        {medias}
        {this.state.programTypesStr.length > 0 && " > "}
        {types}
        {this.props.elections.isElectionChecked && " > ELECTIONS > "}
        {this.props.elections.isElectionChecked && election}
      </div>
    );
  }

  private handleElectionChange(e: any) {
    let value = e.target.value;
    this.setState({
      electionsIDArray: [value],
      electionsID: e.target.value,
    });
    let item = this.props.elections.elections_study_types.filter(
      (x) => x.id === e.target.value
    )[0];
    this.props.setStudyType(item);
    this.state.mediasID !== null &&
      this.state.mediasID.length > 0 &&
      this.props.getCircoList(e.target.value, false, this.state.mediasID);
    if (!isElectionNational(e.target.value)) {
      this.props.getCircoVirtList(e.target.value, false);
    }
  }
  private handleTempsTypesChange(e: any) {
    let value = e.target.value;
    this.setState({
      detailEtudeID: [value],
    });
  }
  private drawElectionsSelect() {
    const { classes, ...other } = this.props;
    return (
      <ElectionSelect
        {...other}
        handleElectionChange={this.handleElectionChange.bind(this)}
        electionsID={this.state.electionsID}
        electionsIDArray={this.state.electionsIDArray}
      />
    );
  }
  private saveMediasChanges(ids: number[], str: string[], bool: boolean) {
    this.setState({
      mediasID: ids,
      mediasStr: str,
      isAllMediasSelected: bool,
    });
    this.state.electionsID !== null &&
      ids.length > 0 &&
      this.props.getCircoList(this.state.electionsID, false, ids);
  }
  private saveProgramTypesChanges(ids: number[], str: string[], bool: boolean) {
    this.setState({
      programTypesID: ids,
      programTypesStr: str,
      isAllProgramTypesSelected: bool,
    });
  }
  private saveProgramEditorsChanges(
    ids: number[],
    str: string[],
    bool: boolean
  ) {
    this.setState({
      programEditorsID: ids,
      programEditorStr: str,
      isAllProgramEditorsSelected: bool,
    });
  }
  private buildProgramNameAutocomplete() {
    const { classes, i18n } = this.props;
    return (
      <MD.FormControl
        className={classes.formControl}
        style={{ padding: "5px 10px 5px 10px" }}
      >
        <Autocomplete
          style={{ width: "100%", marginTop: "8px" }}
          id="program-name-autocomplete"
          value={this.state.programName}
          loadingText={<MD.CircularProgress color="primary" size={20} />}
          loading={this.props.dashboard.isEmissionAutocompleteLoading}
          options={this.props.dashboard.emissions}
          getOptionLabel={(option) => option}
          noOptionsText={i18n._("No options")}
          onChange={(event, value) =>
            this.setState({ programName: value || "" })
          }
          onInputChange={(event, value) => {
            this.setState({ programName: value });
            if (value.length >= 2) {
              const mediaIds = this.state.isAllMediasSelected
                ? this.props.user.allMediasID
                : this.state.mediasID && this.state.mediasID.length > 0
                  ? this.state.mediasID
                  : this.props.user.allMediasID;
              this.props.getAutocompleteEmission(value, mediaIds);
            } else {
              this.props.clearEmissionList();
            }
          }}
          renderInput={(params) => (
            <MD.TextField
              {...params}
              variant="outlined"
              placeholder={i18n._("Nom de l'émission...")}
              InputProps={{
                ...params.InputProps,
                className: classes.inputClasses,
                endAdornment: (
                  <React.Fragment>
                    {this.props.dashboard.isEmissionAutocompleteLoading ? (
                      <MD.CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
          PaperComponent={(props) => (
            <MD.Paper
              {...props}
              style={{
                ...props.style,
                backgroundColor: theme.palette.background.paper,
                border: "1px solid " + theme.palette.divider,
              }}
            />
          )}
          ListboxProps={{
            style: {
              maxHeight: "200px",
              fontSize: "13px",
            },
          }}
        />
      </MD.FormControl>
    );
  }
  public render(): React.ReactNode {
    const { classes, i18n, layout } = this.props;
    let newState = { ...this.state };
    let errorMessageCopy: string = newState.errorMessage;
    let pathParts: string[] = [""];
    if (this.props.router !== undefined) {
      pathParts = this.props.router.location.pathname.split("/");
    }

    const mediaFilter =
      this.state.mediasID !== null && !this.props.search.isLoading
        ? {
          list: this.props.user.medias,
          listID: this.state.mediasID,
          listStr: this.state.mediasStr,
          allListIDs: this.props.user.allMediasID,
          allListStr: this.props.user.allMediasSTR,
          isAllSelected: this.state.isAllMediasSelected,
          saveChanges: this.saveMediasChanges.bind(this),
          multiple: true,
        }
        : undefined;

    const programTypeFilter =
      this.state.programTypesID !== null &&
        this.props.search.programTypes.length > 0 &&
        !this.props.elections.isElectionsLegislative
        ? {
          list: this.props.search.programTypes,
          listID: this.state.programTypesID,
          listStr: this.state.programTypesStr,
          allListIDs: this.props.search.allProgramTypesID,
          allListStr: this.props.search.allProgramTypesSTR,
          isAllSelected: this.state.isAllProgramTypesSelected,
          saveChanges: this.saveProgramTypesChanges.bind(this),
          multiple: true,
        }
        : undefined;

    const canShowProgramEditors =
      this.props.search.allProgramEditorsID !== null &&
      this.state.programEditorsID !== null &&
      this.props.search.programEditors.length > 0 &&
      this.props.router !== undefined &&
      pathParts[1] !== "declarationsARCOM";

    const programEditorFilter = canShowProgramEditors
      ? {
        list: this.props.search.programEditors,
        listID: this.state.programEditorsID,
        listStr: this.state.programEditorStr,
        allListIDs: this.props.search.allProgramEditorsID!,
        allListStr: this.props.search.allProgramEditorsSTR!,
        isAllSelected: this.state.isAllProgramEditorsSelected,
        saveChanges: this.saveProgramEditorsChanges.bind(this),
        multiple: true,
      }
      : undefined;
    const programNameFilter =
      this.props.router !== undefined && pathParts[1] !== "declarationsARCOM"
        ? {
            programName: this.state.programName,
            emissions: this.props.dashboard.emissions,
            isLoading: this.props.dashboard.isEmissionAutocompleteLoading,
            onInputChange: (event: any, value: string) => {
              this.setState({ programName: value });
              if (value.length >= 2) {
                const mediaIds = this.state.isAllMediasSelected
                  ? this.props.user.allMediasID
                  : this.state.mediasID && this.state.mediasID.length > 0
                    ? this.state.mediasID
                    : this.props.user.allMediasID;
                this.props.getAutocompleteEmission(value, mediaIds);
              } else {
                this.props.clearEmissionList();
              }
            },
            onChange: (event: any, value: string | null) =>
              this.setState({ programName: value || "" }),
          }
        : undefined;
    return (
      <>
        {this.buildFiltersInfos()}
        <MD.Drawer
          anchor="left"
          classes={{ paper: classes.drawerPaper }}
          className={
            classes.drawer +
            (!isNullOrUndefined(layout.drawerContent) && layout.showDrawer
              ? ""
              : "hidden")
          }
          open={layout.showDrawer}
          variant="persistent"
        >
          <div>
            <form
              autoComplete={"off"}
              className={classes.form}
              noValidate={true}
            >
              {this.props.search.isLoading && (
                <MD.Grid style={{ margin: "16px" }}>
                  <MD.CircularProgress color="primary" />
                </MD.Grid>
              )}
              {this.props.elections.isElectionChecked &&
                this.state.electionsID !== null &&
                this.state.electionsIDArray.length > 0 &&
                this.drawElectionsSelect()}
              <FiltersSection
                i18n={i18n}
                mediaFilter={mediaFilter}
                mediaTitle={i18n._("Medias")}
                programTypeFilter={programTypeFilter}
                programTypeTitle={i18n._("Program types")}
                programEditorFilter={programEditorFilter}
                programEditorTitle={i18n._("Program editors")}
                programNameFilter={programNameFilter}
                programNameTitle={i18n._("Nom de l'émission...")}
              />
              <PeriodSelection
                ref={this.PeriodRef}
                router={this.props.router}
                saveDates={this.saveDates.bind(this)}
                hideTime={
                  this.props.router !== undefined &&
                  pathParts[1] === "declarationsARCOM"
                }
              />
              {this.props.router !== undefined &&
                pathParts[1] !== "declarationsARCOM" &&
                this.buildSelectDateFormat()}
              {this.buildSearchButton()}
            </form>
            <Dialog
              closeDialog={this.handleClose.bind(this)}
              open={this.state.openError}
              title={"Alert"}
              width={"350px"}
              content={
                <div>
                  {errorMessageCopy
                    .split("\n")
                    .map((paragraph: string, index: number) => {
                      return <p key={index}> {paragraph} </p>;
                    })}
                </div>
              }
              showActions={true}
            />
          </div>
        </MD.Drawer>
      </>
    );
  }
}
const mapStateToProps = (
  { layout, i18n, ui, search, dashboard, user, elections }: IApplicationState,
  ownProps: RouteComponentProps<{}>
) => ({
  layout,
  localeInfos: i18n.localeInfos,
  i18n: i18n.i18n,
  ui,
  search,
  dashboard,
  user,
  router: ownProps,
  elections,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getDashboard: (filters: IFilters) => dispatch(getDashboard(filters)),
  setDisplayFormat: (displayFormat: IDisplayFormat) =>
    dispatch(setDisplayFormat(displayFormat)),
  hideDrawer: () => dispatch(hideDrawer()),
  showDrawer: () => dispatch(showDrawer()),
  resetFilters: () => dispatch(resetFilters()),
  getCircoList: (study_type_id: number, is_nat: boolean, media_ids: number[]) =>
    dispatch(getCircoList(study_type_id, is_nat, media_ids)),
  getCircoVirtList: (study_type_id: number, is_nat: boolean) =>
    dispatch(getCircoVirtList(study_type_id, is_nat)),
  getDashboardElection: (filters: IElectionFilters) =>
    dispatch(getDashboardElection(filters)),
  getDashboardCirconscription: (filters: IElectionFilters) =>
    dispatch(getDashboardCirconscription(filters)),
  getDeclarationCSA: (filters: IDeclarationCSAFilters) =>
    dispatch(getDeclarationCSA(filters)),
  setStudyType: (study_type: IElectionsStudyType) =>
    dispatch(setStudyType(study_type)),
  getTimeAllocation: (filters: IElectionDetailFilters) =>
    dispatch(getTimeAllocation(filters)),
  getTimeAllocationLegislative: (filters: IElectionFilters) =>
    dispatch(getTimeAllocationLegislative(filters)),
  getAutocompleteEmission: (emission_name: string, media_ids?: number[]) =>
    dispatch(getAutocompleteEmission(emission_name, media_ids)),
  clearEmissionList: () => dispatch(clearEmissionList()),
});

export const DashboardDrawer = connect(
  mapStateToProps,
  mapDispatchToProps
)(MD.withTheme(MD.withStyles(styles)(DashboardDrawerComponent)));
